import { MemoryObserver } from '@dateam/ark';

export default new MemoryObserver<Error>();